module.exports = __webpack_public_path__ + "static/img/trrafic-place-icon.8dce5cdd.svg";